const state = {
  globalMessage: { variant: null, message: null }
}

const getters = {
  getGlobalMessage: (state) => state.globalMessage
}

const mutations = {
  setGlobalMessage: (state, payload) => {
    state.globalMessage = payload
  }
}

const actions = {
  setGlobalMessage: ({ commit }, payload) => {
    if (!payload.variant) {
      commit('setGlobalMessage', { variant: 'success', message: payload })

      return
    }

    commit('setGlobalMessage', payload)
  },
  clearGlobalMessage: ({ commit }) => {
    commit('setGlobalMessage', { variant: null, message: null })
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
